(function () {
  if (window.__csCatalogueInit) return;
  window.__csCatalogueInit = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function fetchHtml(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.text(); });
  }

  function syncChipActiveState() {
    var params = new URLSearchParams(window.location.search);
    var paramKeys = Array.from(params.keys());
    $$('[data-cs-filter-trigger]').forEach(function (chip) {
      var key = chip.getAttribute('data-filter-key');
      if (!key) { chip.classList.remove('is-active'); return; }
      var hit = paramKeys.some(function (k) { return k === key || k.indexOf(key + '.') === 0; });
      chip.classList.toggle('is-active', hit);
    });
  }

  function replaceGrid(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('[data-cs-grid-items]');
    var newCount = doc.querySelector('[data-cs-result-count]');
    var newMore = doc.querySelector('[data-cs-loadmore]');
    var newActive = doc.querySelector('.cs-filter-bar__row--active');

    var curGrid = $('[data-cs-grid-items]');
    var curCount = $$('[data-cs-result-count]');
    var curMore = $('[data-cs-loadmore]');
    var curActive = $('.cs-filter-bar__row--active');

    if (curGrid && newGrid) curGrid.innerHTML = newGrid.innerHTML;
    if (newCount) {
      curCount.forEach(function (el) { el.textContent = newCount.textContent; });
    }
    if (curMore && newMore) {
      curMore.outerHTML = newMore.outerHTML;
    } else if (curMore && !newMore) {
      curMore.remove();
    }
    if (curActive && newActive) {
      curActive.outerHTML = newActive.outerHTML;
    } else if (curActive && !newActive) {
      curActive.remove();
    } else if (!curActive && newActive) {
      var bar = $('.cs-filter-bar .cs-container');
      if (bar) bar.insertAdjacentHTML('beforeend', newActive.outerHTML);
    }
    syncChipActiveState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncChipActiveState);
  } else {
    syncChipActiveState();
  }

  function closeAllPopovers() {
    $$('.cs-filter-bar__popover').forEach(function (p) { p.hidden = true; });
    $$('[data-cs-filter-trigger]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cs-filter-trigger]');
    if (trigger) {
      e.preventDefault();
      var key = trigger.getAttribute('data-filter-key');
      var pop = $('[data-cs-filter-popover][data-filter-key="' + key + '"]');
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllPopovers();
      if (!isOpen && pop) {
        pop.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (!e.target.closest('.cs-filter-bar__popover') && !e.target.closest('[data-cs-filter-trigger]')) {
      closeAllPopovers();
    }
  });

  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-cs-filter-apply]');
    if (!apply) return;
    var pop = apply.closest('[data-cs-filter-popover]');
    if (!pop) return;
    var key = pop.getAttribute('data-filter-key');
    var url = new URL(window.location.href);

    var inputs = $$('[data-cs-filter-input]', pop);
    if (inputs.length > 0) {
      url.searchParams.delete(key);
      inputs.forEach(function (i) {
        if (i.checked) url.searchParams.append(i.name, i.value);
      });
    }
    var min = $('[data-cs-filter-range-min]', pop);
    var max = $('[data-cs-filter-range-max]', pop);
    if (min && max) {
      var minName = key + '.gte';
      var maxName = key + '.lte';
      url.searchParams.delete(minName);
      url.searchParams.delete(maxName);
      if (min.value && Number(min.value) > 0) url.searchParams.set(minName, min.value);
      if (max.value && Number(max.value) > 0) url.searchParams.set(maxName, max.value);
    }
    url.searchParams.delete('page');
    history.pushState({}, '', url.toString());
    fetchHtml(url.toString()).then(replaceGrid).then(closeAllPopovers);
  });

  document.addEventListener('click', function (e) {
    var clear = e.target.closest('[data-cs-filter-clear]');
    if (!clear) return;
    var key = clear.getAttribute('data-filter-key');
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (k) {
      if (k.indexOf(key) === 0) url.searchParams.delete(k);
    });
    history.pushState({}, '', url.toString());
    fetchHtml(url.toString()).then(replaceGrid);
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cs-filter-remove]');
    if (!chip) return;
    e.preventDefault();
    var url = chip.getAttribute('href');
    history.pushState({}, '', url);
    fetchHtml(url).then(replaceGrid);
  });

  document.addEventListener('click', function (e) {
    var reset = e.target.closest('[data-cs-filter-reset]');
    if (!reset) return;
    e.preventDefault();
    var url = reset.getAttribute('href');
    history.pushState({}, '', url);
    fetchHtml(url).then(replaceGrid);
  });

  document.addEventListener('change', function (e) {
    var sort = e.target.closest('[data-cs-sort]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    history.pushState({}, '', url.toString());
    fetchHtml(url.toString()).then(replaceGrid);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cs-loadmore-btn]');
    if (!btn) return;
    var wrap = btn.closest('[data-cs-loadmore]');
    if (!wrap) return;
    var nextUrl = wrap.getAttribute('data-next-url');
    if (!nextUrl) return;
    btn.disabled = true;
    btn.textContent = 'Chargement…';
    fetchHtml(nextUrl).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newItems = doc.querySelectorAll('[data-cs-grid-items] > *');
      var grid = $('[data-cs-grid-items]');
      newItems.forEach(function (el) { grid.appendChild(el); });

      var newWrap = doc.querySelector('[data-cs-loadmore]');
      if (newWrap) {
        wrap.outerHTML = newWrap.outerHTML;
      } else {
        wrap.classList.add('is-end');
        btn.remove();
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Voir plus';
    });
  });

  function buildMobileDrawer() {
    var existing = $('[data-cs-mobile-drawer]');
    if (existing) return existing;
    var drawer = document.createElement('div');
    drawer.className = 'cs-filter-drawer';
    drawer.setAttribute('data-cs-mobile-drawer', '');
    drawer.innerHTML = '\
      <div class="cs-filter-drawer__backdrop" data-cs-drawer-close></div>\
      <aside class="cs-filter-drawer__panel" role="dialog" aria-label="Filtres">\
        <header><span>Filtrer</span><button type="button" data-cs-drawer-close aria-label="Fermer">✕</button></header>\
        <div class="cs-filter-drawer__body" data-cs-drawer-body></div>\
        <footer><button type="button" class="cs-btn cs-btn--violet" data-cs-drawer-apply>Voir <span data-cs-drawer-count>0</span> produits</button></footer>\
      </aside>';
    document.body.appendChild(drawer);
    return drawer;
  }

  function openMobileDrawer(mode) {
    var drawer = buildMobileDrawer();
    var body = $('[data-cs-drawer-body]', drawer);
    body.innerHTML = '';
    if (mode === 'filter') {
      $$('[data-cs-filter-popover]').forEach(function (pop) {
        var clone = pop.cloneNode(true);
        clone.removeAttribute('hidden');
        clone.classList.add('cs-filter-drawer__group');
        var title = document.createElement('h4');
        title.textContent = pop.getAttribute('aria-label') || pop.getAttribute('data-filter-key');
        body.appendChild(title);
        body.appendChild(clone);
      });
    } else if (mode === 'sort') {
      var sort = $('[data-cs-sort]');
      if (sort) body.appendChild(sort.cloneNode(true));
    }
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    updateDrawerCount();
  }

  function closeMobileDrawer() {
    var drawer = $('[data-cs-mobile-drawer]');
    if (drawer) drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function updateDrawerCount() {
    var countEl = $('[data-cs-drawer-count]');
    if (!countEl) return;
    var current = $('[data-cs-result-count]');
    if (current) countEl.textContent = (current.textContent.match(/\d+/) || ['0'])[0];
  }

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-cs-filter-mobile-trigger]');
    if (trig) {
      openMobileDrawer(trig.getAttribute('data-cs-filter-mobile-trigger'));
      return;
    }
    if (e.target.closest('[data-cs-drawer-close]')) {
      closeMobileDrawer();
      return;
    }
    var apply = e.target.closest('[data-cs-drawer-apply]');
    if (apply) {
      var drawer = $('[data-cs-mobile-drawer]');
      if (!drawer) return;
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0) url.searchParams.delete(k);
      });
      $$('input[type="checkbox"]:checked', drawer).forEach(function (i) {
        url.searchParams.append(i.name, i.value);
      });
      var sort = $('[data-cs-sort]', drawer);
      if (sort) url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      history.pushState({}, '', url.toString());
      fetchHtml(url.toString()).then(replaceGrid).then(closeMobileDrawer);
    }
  });

  window.addEventListener('popstate', function () {
    fetchHtml(window.location.href).then(replaceGrid);
  });

  /* ==========================================================
   * Quick-add modal
   * ======================================================== */
  var qaTriggerEl = null;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
  function formatMoney(cents) {
    var v = Number(cents) / 100;
    return v.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function uniqueValuesForOption(variants, idx) {
    var seen = {};
    var out = [];
    variants.forEach(function (v) {
      var val = v.options[idx];
      if (val && !seen[val]) { seen[val] = true; out.push(val); }
    });
    return out;
  }

  function isFirstAvailableForOption(variants, idx, value) {
    var firstWithVal = variants.find(function (v) { return v.options[idx] === value && v.available; });
    if (!firstWithVal) return false;
    var firstAvail = variants.find(function (v) { return v.available; });
    return firstWithVal === firstAvail;
  }

  function buildModalContent(prod) {
    var html = '';
    html += '<div class="cs-quickadd__hd">';
    if (prod.featured_image) {
      html += '<img class="cs-quickadd__img" src="' + prod.featured_image + '" alt="" loading="lazy">';
    }
    html += '<div class="cs-quickadd__info">';
    html += '<h2 class="cs-quickadd__title" id="cs-quickadd-title">' + escapeHtml(prod.title) + '</h2>';
    html += '<p class="cs-quickadd__price" data-qa-price>' + formatMoney(prod.price) + '</p>';
    html += '</div>';
    html += '</div>';

    if (prod.options && prod.options.length > 0) {
      html += '<div class="cs-quickadd__options">';
      prod.options.forEach(function (opt, idx) {
        var optName = (typeof opt === 'string') ? opt : (opt.name || ('Option ' + (idx + 1)));
        html += '<div class="cs-quickadd__opt-group" data-opt-idx="' + idx + '">';
        html += '<label class="cs-quickadd__opt-label">' + escapeHtml(optName) + '</label>';
        html += '<div class="cs-quickadd__pills">';
        var values = uniqueValuesForOption(prod.variants, idx);
        values.forEach(function (val) {
          var firstAvail = isFirstAvailableForOption(prod.variants, idx, val);
          html += '<button type="button" class="cs-quickadd__pill ' + (firstAvail ? 'is-active' : '') + '" data-opt-val="' + escapeAttr(val) + '" data-opt-idx="' + idx + '">' + escapeHtml(val) + '</button>';
        });
        html += '</div></div>';
      });
      html += '</div>';
    }

    html += '<div class="cs-quickadd__foot">';
    html += '<button type="button" class="cs-btn cs-btn--violet cs-btn--lg" data-qa-add>Ajouter au panier · <span data-qa-cta-price>' + formatMoney(prod.price) + '</span></button>';
    html += '<a href="' + prod.url + '" class="cs-quickadd__link">Voir la fiche complète →</a>';
    html += '</div>';

    return html;
  }

  function findVariantBySelection(prod, selected) {
    return prod.variants.find(function (v) {
      return v.options.every(function (val, idx) { return val === selected[idx]; });
    });
  }

  function getCurrentSelection(modal, prod) {
    var sel = [];
    prod.options.forEach(function (_, idx) {
      var pill = modal.querySelector('.cs-quickadd__pill.is-active[data-opt-idx="' + idx + '"]');
      sel[idx] = pill ? pill.getAttribute('data-opt-val') : null;
    });
    return sel;
  }

  window.csOpenQuickAddModal = function (prod, triggerEl) {
    qaTriggerEl = triggerEl || null;
    var modal = $('[data-cs-quickadd]');
    if (!modal) return;
    var body = $('[data-cs-quickadd-body]', modal);
    body.innerHTML = buildModalContent(prod);
    modal.dataset.productHandle = prod.handle;
    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var closeBtn = modal.querySelector('.cs-quickadd__close, [data-cs-quickadd-close]:not(.cs-quickadd__backdrop)');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    });

    body.addEventListener('click', function bodyHandler(e) {
      var pill = e.target.closest('.cs-quickadd__pill');
      if (pill) {
        var idx = pill.getAttribute('data-opt-idx');
        var siblings = body.querySelectorAll('.cs-quickadd__pill[data-opt-idx="' + idx + '"]');
        siblings.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var sel = getCurrentSelection(modal, prod);
        var match = findVariantBySelection(prod, sel);
        if (match) {
          var priceEls = body.querySelectorAll('[data-qa-price],[data-qa-cta-price]');
          priceEls.forEach(function (el) { el.textContent = formatMoney(match.price); });
        }
        return;
      }
      var add = e.target.closest('[data-qa-add]');
      if (add) {
        var sel2 = getCurrentSelection(modal, prod);
        var match2 = findVariantBySelection(prod, sel2);
        if (!match2 || !match2.available) {
          add.classList.add('is-error');
          setTimeout(function () { add.classList.remove('is-error'); }, 1600);
          return;
        }
        add.disabled = true;
        add.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: match2.id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            add.classList.remove('is-loading');
            add.classList.add('is-success');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:added'));
            setTimeout(function () { closeModal(); }, 800);
          })
          .catch(function () {
            add.classList.remove('is-loading');
            add.classList.add('is-error');
            setTimeout(function () {
              add.classList.remove('is-error');
              add.disabled = false;
            }, 1600);
          });
      }
    });
  };

  function closeModal() {
    var modal = $('[data-cs-quickadd]');
    if (!modal) return;
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (qaTriggerEl && qaTriggerEl.focus) qaTriggerEl.focus();
      qaTriggerEl = null;
    }, 280);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cs-quickadd-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    var modal = $('[data-cs-quickadd]');
    if (!modal || modal.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key !== 'Tab') return;
    var focusables = modal.querySelectorAll(
      'button:not([disabled]):not([hidden]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ==========================================================
   * Empty state Mimi — bouton "Demander à Mimi" + search suggest
   * ======================================================== */
  document.addEventListener('click', function (e) {
    var ask = e.target.closest('[data-cs-empty-mimi-ask]');
    if (!ask) return;
    var trigger = document.querySelector('[data-cs-mimi-trigger]');
    if (trigger) trigger.click();
    setTimeout(function () {
      var tabChat = document.querySelector('.cs-mimi__tab[data-tab="chat"]');
      if (tabChat) tabChat.click();
      var input = document.querySelector('[data-cs-mimi-input]');
      if (input) {
        input.value = 'Aide-moi à choisir';
        input.focus();
      }
    }, 350);
  });

  /* Search 0-result suggestion (run on DOM ready) */
  function csEmptyMimiSearchSuggest() {
    var suggestEl = document.querySelector('[data-cs-empty-suggest]');
    if (!suggestEl) return;
    var query = (new URLSearchParams(location.search).get('q') || '').toLowerCase();
    if (!query) return;
    var rules = [
      { match: /sommeil|dormir|insomnie|nuit/, label: 'Huile CBN', url: '/collections/nos-huiles' },
      { match: /débuter|debutant|débutant|premier|nouveau|tester|découvrir|decouverte|découverte/, label: 'Pack Découverte', url: '/collections/toutes-nos-fleurs' },
      { match: /fort|puissant|haut taux|costaud/, label: 'Fleurs CBD ≥17 %', url: '/collections/toutes-nos-fleurs' },
      { match: /détente|detente|stress|anxiété|anxiete|relaxation/, label: 'Huile Full Spectrum', url: '/collections/nos-huiles' }
    ];
    var hit = rules.find(function (r) { return r.match.test(query); });
    if (hit) {
      suggestEl.innerHTML = 'Tu cherches « ' + escapeHtml(query) + ' » ? Mimi te conseille <a href="' + hit.url + '"><strong>' + hit.label + '</strong></a> →';
      suggestEl.removeAttribute('hidden');
    } else {
      suggestEl.innerHTML = 'Pas sûr ? <button type="button" class="cs-link" data-cs-empty-mimi-ask>Demande à Mimi</button>, elle t\'orientera.';
      suggestEl.removeAttribute('hidden');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', csEmptyMimiSearchSuggest);
  } else {
    csEmptyMimiSearchSuggest();
  }
})();
